<template>
  <div class="segment-text mt-[20px]">
    <div
      :class="['title flex cursor-pointer', { show: open }]"
      @click="open = !open"
    >
      {{ $t('shi-pin-jiao-ben') }}
      <iconpark-icon name="down" class="ml-[5px]"></iconpark-icon>
    </div>
    <div
      v-show="open"
      class="content border-gray-500 max-h-[200px] overflow-auto mt-[10px] px-[20px]"
    >
      <p
        v-for="(line, idx) in (text || '')?.split('\n')"
        :key="idx"
        class="leading-[16px]"
      >
        {{ line }}
      </p>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  text: string
}>()
const open = ref(true)
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  &.show {
    iconpark-icon {
      transform: rotate(180deg);
    }
  }
}
.content {
  border: 1px solid var(--back-3);
  background-color: var(--back-2);
  font-size: 12px;
}
</style>
